import { render } from "./OnBoardingParker.vue?vue&type=template&id=d2990f5a&scoped=true"
import script from "./OnBoardingParker.vue?vue&type=script&lang=js"
export * from "./OnBoardingParker.vue?vue&type=script&lang=js"

import "./OnBoardingParker.vue?vue&type=style&index=0&id=d2990f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2990f5a"]])

export default __exports__